<template>
  <b-modal v-model="c_show" title="Edit Contact" hide-footer @hide="onHide">
    <b-form>
      <b-form-group label="Phone Number" v-if="form.phone_number">
        <b>{{ form.phone_number }}</b>
        <!-- <b-input-group>
          <template #prepend>
            <el-select v-model="form.country_code" filterable size="small" disabled>
              <el-option v-for="(item, index) in country_code" :key="index" :value="item.dial_code" :label="item.dial_code + ' (' +  item.name +')'"/>
            </el-select>
          </template>
          <div>
            <b-form-input class="ml-2" id="i-user-phone" type="text" disabled v-model="v$.form.phone_number.$model" placeholder="Contact phone. eg: 8123456" />
            <b-form-invalid-feedback class="ml-2" :state="!v$.form.name.$invalid" v-if="v$.form.name.$errors[0]">
              {{ v$.form.name.$errors[0].$message }}
            </b-form-invalid-feedback>
          </div>
        </b-input-group> -->
      </b-form-group>
      <b-form-group label="User ID" v-if="form.user_id">
        <b>{{ form.user_id }}</b>
      </b-form-group>
      <b-form-group label="Name">
        <b-form-input id="i-user-name" type="text" v-model="form.name" placeholder="Input contact name" />
        <b-form-invalid-feedback :state="!v$.form.name.$invalid" v-if="v$.form.name.$errors[0]">
          {{ v$.form.name.$errors[0].$message }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <label for="input-email">Label</label><br/>
        <el-select class="w-100" :loading="loading.label" :loading-text="$t('general.loading')" @change="selectedLabelChanged" multiple size="small" v-model="v$.selected_label.$model">
          <el-option v-for="(label) in label_list" :key="label.id" :value="label.id"
            :label="label.title"
          />
        </el-select>
        <b-form-invalid-feedback :state="!v$.selected_label.$invalid" v-if="v$.selected_label.$errors[0]">
          {{ v$.selected_label.$errors[0].$message }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group :label="v.label" :key="v.key" v-for="(v,i) in custom_fields">
        <b-form-input :id="`i-${v.key}`" type="text" v-model="form.custom_data[i].value" :placeholder="`Input ${v.label}`" />
      </b-form-group>
      <b-form-group>
        <label for="input-agent">Dedicated agent (optional)</label><br/>
        <el-select class="w-100" filterable clearable :loading="loading.agent" :loading-text="$t('general.loading')" size="small" v-model="form.dedicated_agent_user_id">
          <el-option v-for="(agent) in agent_list" :key="agent.user_id" :value="agent.user_id"
            :label="agent.user.name"
          />
        </el-select>
      </b-form-group>
      <div class="d-flex flex-row mt-2 float-right">
        <b-button type="submit" variant="primary" class="mr-2">{{ $t('general.submit') }}</b-button>
        <b-button type="reset" @click="onHide" variant="secondary">{{ $t('general.cancel') }}</b-button>
      </div>
    </b-form>
  </b-modal>
</template>
<script>
import useVuelidate from '@vuelidate/core';
import {
  required,
} from '@vuelidate/validators';
import labels from '@/api/labels';
import agents from '@/api/agents';
import { phone } from 'phone';
import country_code from '../../../library/full-country-code.json';

export default {
  name: 'ContactsSingleEdit',
  setup() {
    return { v$: useVuelidate() };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    selectedContact: {
      type: Object,
      default() {
        return {};
      },
    },
    selectedContactFields: {
      type: Array,
      default() {
        return [];
      },
    },
    selectedContactCustomData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  validations() {
    return {
      form: {
        name: { required },
        phone_number: { required },
      },
      selected_label: { required },
    };
  },
  data() {
    return {
      form: {
        name: '',
        phone_number: '',
        country_code: '+62',
        custom_data: [],
        dedicated_agent_user_id: null,
        user_id: '',
      },
      country_code,
      c_show: false,
      loading: {
        label: false,
        field: false,
        agent: false,
      },
      label_list: [],
      custom_fields: [],
      agent_list: [],
      selected_label: [],
    };
  },
  computed: {
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace;
    },
  },
  methods: {
    onHide() {
      this.v$.$reset();
      this.clearInput();
      this.c_show = false;
      this.$emit('onHide');
    },
    async getLabelList() {
      this.loading.label = true;
      await labels.getList(this.activeWorkspace._id)
        .then((response) => {
          this.label_list = response.data.rows;
        });
      this.loading.label = false;
    },
    async getAgentList(search_keyword = null) {
      this.loading.agent = true;
      await agents.getList(this.activeWorkspace._id, 1, search_keyword)
        .then((response) => {
          this.agent_list = response.data.rows;
        });
      this.loading.agent = false;
    },
    // async getCustomFields() {
    //   this.loading.field = true;
    //   await contactsApi.get_field({
    //     workspace_id: this.activeWorkspace._id,
    //   }).then((response) => {
    //     this.custom_fields = response.data.fields;
    //   });
    //   this.loading.field = false;
    // },
    selectedLabelChanged() {},
    selectedPhoneNumber() {
      const phone_number = this.selectedContact.contact.phone_number || this.selectedContact.phone_number;
      const cc = phone(`+${phone_number}`);
      if (cc.isValid) {
        this.form.country_code = cc.countryCode;
        const phoneNumber = this.isChatPrivacy(phone_number);
        this.form.phone_number = phoneNumber;
      } else {
        this.form.phone_number = this.isChatPrivacy(phone_number);
      }
    },
    onSubmit() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }
      const phone_number = this.selectedContact.contact.phone_number || this.selectedContact.phone_number;
      const data = {
        phone: phone_number,
        name: this.form.name,
        labels_id: this.selected_label || [],
        custom_data: this.form.custom_data,
        dedicated_agent_user_id: this.form.dedicated_agent_user_id,
      };
      // const custom_data_filled = this.form.custom_data.filter((v) => v.value);
      // if (custom_data_filled.length > 0) {
      //   data.custom_data = custom_data_filled;
      // }
      // data.custom_data = this.form.custom_data;
      this.clearInput();
      this.$emit('onSubmit', data);
    },
    clearInput() {
      this.form = {
        name: '',
        phone_number: '',
        country_code: '+62',
        custom_data: [],
      };
      this.selected_label = [];
    },
    isChatPrivacy(number) {
      let phone_number = number;
      if (phone_number && this.$store.state.auth.userProfile.is_pic !== true && this.$store.state.auth.userProfile.agents && this.$store.state.auth.userProfile.agents[0] && this.activeWorkspace.configuration && this.activeWorkspace.configuration.chat_privasi && this.activeWorkspace.configuration.chat_privasi.masking_phone_number === true) {
        if (number.charAt(0) === '0') {
          phone_number = number.replace('0', '62');
        }
        const validateRegex = /^\+?[1-9][0-9]{4,14}$/;
        if (phone_number && validateRegex.test(`${phone_number}`)) {
          return `********${phone_number.substring(phone_number.length - 2)}`;
        }
      }
      return phone_number;
    },
  },
  watch: {
    show() {
      this.c_show = this.show;
      this.custom_fields = this.selectedContactFields;
      this.custom_fields.forEach((v, i) => {
        const field_value = this.selectedContactCustomData[v.key];
        if (field_value) {
          this.form.custom_data[i] = {
            key: v.key,
            value: field_value,
          };
        } else {
          this.form.custom_data[i] = {
            key: v.key,
            value: '',
          };
        }
      });
      this.form.name = this.selectedContact.contact.display_name || this.selectedContact.name;
      this.form.user_id = this.selectedContact.contact.user_id || this.selectedContact.user_id;
      const list_labels = this.selectedContact.labels || this.selectedContact.contact.labels;
      if (list_labels) {
        this.selected_label = list_labels.map((v) => v.id);
      } else {
        this.selected_label = [];
      }
      this.selectedPhoneNumber();
      this.getLabelList();
      this.getAgentList();
      if (this.selectedContact.contact?.dedicated_agent_user_id) {
        this.form.dedicated_agent_user_id = this.selectedContact.contact?.dedicated_agent_user_id;
      }
    },
  },
};
</script>
